import type { MonitoringAdapter } from './monitoring.types.ts';

const WARN_PREFIX = '[api-client/monitoring]';

const noopAdapter: MonitoringAdapter = {
  captureError: (error, context) => {
    console.warn(`${WARN_PREFIX} captureError invoked before configureMonitoring ran; the error will not reach the host app monitoring.`, {
      error,
      context
    });
  },
  setGlobalContextProperty: (key, value) => {
    console.warn(
      `${WARN_PREFIX} setGlobalContextProperty invoked before configureMonitoring ran; the value will not reach the host app monitoring.`,
      { key, value }
    );
  }
};

let adapter: MonitoringAdapter = noopAdapter;

export function configureMonitoring(config: MonitoringAdapter): void {
  adapter = config;
}

export function getMonitoring(): MonitoringAdapter {
  return adapter;
}
